module.exports = __webpack_public_path__ + "img/capehayate_032024KV.bf284539.jpg";